module.exports = __webpack_public_path__ + "static/media/5 1 Leseforstaelse Intro.cce2cc9c.mp3";